import React from 'react';
import { LocalPopup } from 'js/components/common/Popup';

import { Layout } from 'js/components/system/Page/components/Layout';
import { getRootClassNames } from 'js/components/system/Page/helpers';

import { useGetIsPageAsPopupHasCustomHeader, useGetOnPageAsPopupCloseMethods } from './hooks';

import style from './PagePopup.scss';

export const PagePopup = ({ page, isLoading }) => {
    const { isShowAsModal = false } = page;
    const isPageInPopupHasThemeHeader = useGetIsPageAsPopupHasCustomHeader();
    const { onClose, onOverlayClick } = useGetOnPageAsPopupCloseMethods(page || {});

    const { popupWidth, popupWidthUnit, hidePopUpTitle, title, rootClassNames } = page;
    const popupStyle = popupWidth ? { width: `${popupWidth}${popupWidthUnit}` } : {};
    const specialClassName = isPageInPopupHasThemeHeader ? style.noPadding : '';
    const specialClassNames = isPageInPopupHasThemeHeader ? {
        close: style.close,
        inner: style.inner,
        header: style.header
    } : {};

    return (
        <LocalPopup
            onClose={onClose}
            style={popupStyle}
            isModal={isShowAsModal}
            classNames={specialClassNames}
            onOverlayClick={onOverlayClick}
            title={hidePopUpTitle ? undefined : title}
            className={`${style.container} ${getRootClassNames(rootClassNames).join(' ')} ${specialClassName}`}
        >
            <Layout page={page} isLoading={isLoading} isPageInPopup />
        </LocalPopup>
    );
};
